import { ReactNode } from 'react';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { Stack, Typography } from '@rossum/ui/material';
import * as animationData from './animations/error.json';

type MetabaseErrorProps = {
  title: ReactNode;
  description: ReactNode;
};

const MetabaseError = ({ title, description }: MetabaseErrorProps) => (
  <>
    <Lottie
      loop
      play
      animationData={animationData}
      style={{
        height: '250px',
        width: '250px',
      }}
    />
    <Stack width={380} spacing={2}>
      <Typography variant="h5" color="text.secondary" fontWeight="bold">
        {title}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Stack>
  </>
);

export { MetabaseError };
